import { Icon } from "@blueprintjs/core";
import { Tooltip2 } from "@blueprintjs/popover2";

interface Props {
  text: React.ReactNode;
  verticalOffset?: string;
  intent?: "danger" | "info";
  size?: number;
}

export const InfoTooltip: React.FC<Props> = ({ text, verticalOffset, intent, size }) => {
  const iIntent = intent ?? "info";

  const color = { info: "#215383", danger: "#EB3A3A" }[iIntent];

  return (
    // Negative marginTop is used to "align" Icon next to simple text.
    <div
      style={{ margin: `${verticalOffset ?? "0"} 4px 4px 4px`, display: "inline-block" }}
      className="InfoTooltip_customMargin"
    >
      <Tooltip2 popoverClassName="bg-custom-blue" content={<>{text}</>}>
        <Icon icon="info-sign" color={color} size={size} />
      </Tooltip2>
    </div>
  );
};
